import React from "react";
import { Drawer } from "antd";
import { HELP_SECTIONS } from "./CompareHelpContent";
import "./CompareHelpDrawer.css";

const CompareHelpDrawer = ({ open, onClose }) => (
  <Drawer
    title="How to Read This Page"
    placement="right"
    visible={open}
    onClose={onClose}
    width={420}
    className="chd-drawer"
    headerStyle={{ borderBottom: "1px solid #e5e7eb" }}
  >
    <div className="chd-content">
      {HELP_SECTIONS.map((sec, i) => (
        <div key={sec.id} className="chd-section">
          <div className="chd-section-title">
            <span className="chd-section-num">{i + 1}</span>
            {sec.title}
          </div>
          <div className="chd-section-body">
            {sec.body.map((line, j) => (
              <p key={j}>{line}</p>
            ))}
          </div>
        </div>
      ))}
    </div>
  </Drawer>
);

export default CompareHelpDrawer;
